/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export default {
	'.MuiTypography-root': {
		backgroundColor: 'rgba(255, 255, 255, 0.5)',
		boxShadow: '0px 0px 30px white',
		display: 'inline-block',
		borderRadius: '6px',
		color: 'black',
	},
} as SxProps;
